module.exports = __webpack_public_path__ + "img/13.d7202369.jpg";